import Vue from 'vue'
import Vuex from 'vuex'
import json from '../config.json'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
      started: false,
      config: json,
      answers: null,
      quizQuestions: null,
      correctCount: null,
      noOfQuestions: null
    },
    mutations: {
        setAnswers(state, answers) {
            state.answers = answers;
        },
        setQuizQuestions(state, quizQuestions) {
            state.quizQuestions = quizQuestions;
        },
        setCorrectCount(state, count) {
            state.correctCount = count;
        },
        setNoOfQuestions(state, count) {
            state.noOfQuestions = count;
        }
    }
});

